export enum EMarketingChannelsType {
    DIRECT,
    EMAIL,
    REFERRALS,
    SOCIAL,
    ORGANIC_SEARCH,
    PAID_SEARCH,
    DISPLAY_ADS,
}

export interface IChannelConstant {
    API_RESULTS_NAME: string | string[];
    SINGLE_MODE_KEY: string;
    COMPARE_MODE_KEY: string;
    DISPLAY_NAME_KEY: string;
    COLOR: string;
}

export interface TrafficSourcesPieChartResponse {
    Data: {
        Total?: Record<string, Record<string, number>>;
    } & Record<string, Record<string, number>>;
}

export interface EData {
    Data: {};
}
